var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1033 6.81699C15.4701 6.07374 16.5299 6.07374 16.8967 6.81699L19.0001 11.079C19.1458 11.3741 19.4274 11.5787 19.7531 11.626L24.4565 12.3094C25.2767 12.4286 25.6042 13.4366 25.0107 14.0151L21.6073 17.3326C21.3716 17.5624 21.264 17.8934 21.3197 18.2178L22.1231 22.9021C22.2632 23.719 21.4058 24.342 20.6722 23.9563L16.4653 21.7446C16.174 21.5915 15.826 21.5915 15.5347 21.7446L11.3278 23.9563C10.5942 24.342 9.73677 23.719 9.87688 22.9021L10.6803 18.2178C10.736 17.8934 10.6284 17.5624 10.3927 17.3326L6.98933 14.0151C6.39581 13.4366 6.72332 12.4286 7.54354 12.3094L12.2469 11.626C12.5726 11.5787 12.8542 11.3741 12.9999 11.079L15.1033 6.81699Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStar);
export default __webpack_public_path__ + "static/media/Ico_Star.53706bbeb7cb4653fdc7ad09a012fd60.svg";
export { ForwardRef as ReactComponent };